<template>

    <Toast/>

    <div class="px-6 surface-overlay relative">

        <div v-show="activeTab === 1" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3 class="payment-failed">Payment Failed: {{ paymentReference }}</h3>

                    <div v-if="loading" class="field">
                        <label>Loading payment status…</label>
                    </div>

                    <div v-else-if="error" class="field">
                        <label class="text-red-500">Error: {{ error }}</label>
                    </div>

                    <div v-else>
                        <h3 class="mt-6">Invoice Details</h3>

                        <div class="field">
                            <label for="companyName" class="text-900">Company</label>
                            {{ paymentStatus.company.name }}
                        </div>

                        <div class="field">
                            <label for="clientName" class="text-900">Client</label>
                            {{ paymentStatus.invoice.clientName }}
                        </div>

                        <div class="field">
                            <label for="invoiceNumber" class="text-900">Invoice Date</label>
                            {{ paymentStatus.invoice.invoiced }}
                        </div>

                        <div class="field">
                            <label for="invoiceNumber" class="text-900">Invoice Number</label>
                            {{ paymentStatus.invoice.uniqueId }}
                        </div>

                        <div class="field payment-failed">
                            <label for="invoiceAmount" class="text-900">Amount</label>
                            {{ formatAmount(paymentStatus.invoice.amount) }}
                        </div>

                        <div class="field payment-failed">
                            <label for="responseMessage" class="text-900">Message</label>
                            <div style="display: inline; margin-left: 5px; font-weight: bold;" v-if="paymentStatus.responseMessage">{{ paymentStatus.responseMessage }}</div>
                            <div style="display: inline; margin-left: 5px; font-weight: bold;" v-else>Payment Cancelled</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import DnaPaymentsService from "@/service/DnaPaymentsService";
import numeral from "numeral";

export default {
    components: {
        IsoEvolveFooter
    },
    async mounted() {
        console.log("[GbpPaymentError][mounted] this.paymentReference = ", this.paymentReference);

        if (this.paymentReference != null) {
            const res = await DnaPaymentsService.getPaymentStatus(
                this.paymentReference
            );

            if (res.data.error) {
                this.error = res.data.error;
                console.log('[GbpPaymentError][mounted] this.error = ', this.error);
            } else {
                this.paymentStatus = res.data;
                console.log('[GbpPaymentError][mounted] this.paymentStatus = ', this.paymentStatus);
            }

            this.$toast.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Payment Failed',
                life: 3000
            });
        }
        this.loading = false;
    },
    data() {
        return {
            profile: {},
            submitted: false,
            activeTab: 1,
            loading: true,
            error: '',
            paymentReference: this.$route.query.paymentReference ?? null,
            paymentStatus: null,
        }
    },
    methods: {
        formatAmount(value) {
            if (value) {
                return numeral(String(value)).format('0,0.00');
            } else {
                return numeral(String(0)).format('0,0.00');
            }
        },
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}

.payment-failed {
    color: #C63737;
}
</style>
